/* eslint no-underscore-dangle: 0 */

import { render } from '@resn/gozer-core';
// import createLogger from '../core/create-logger';
// import { onChangeDevMode } from '../core/dev-mode';
import { observe } from '@resn/gozer-core/reactivity';
import cacheUI from '@resn/gozer-dom/cache-ui';

const noop = () => {};

let devMode;
// onChangeDevMode((value) => {
//     devMode = value;
// });

const DomComponentMixin = {
    onSetup() {
        if (this.options.__log) {
            // this.__domComponentMixinLog = createLogger({
            //     prefix: `DomComponentMixin.${this.__id}`,
            //     backgroundColor: 'darksalmon',
            //     textColor: 'white',
            // });
            this.__domComponentMixinLog = (message) => {
                console.log(`DomComponentMixin.${this.__id} ${message}`);
            };
        } else {
            this.__domComponentMixinLog = noop;
        }

        // console.log('onSetup', this.__id, this.options.template);
        if (this.options.template) {
            if (devMode) {
                this.__domComponentMixinLog('onSetup() - setup template');
            }

            let hasRendered = false;

            this.fragment = document.createDocumentFragment();
            const templatePayload = { props: this.props, options: this.options, context: this };

            let resolveFirstRender;
            const promiseFirstRender = new Promise((resolve) => {
                resolveFirstRender = resolve;
            });

            const renderTemplate = () => {
                // if (devMode) {
                //     this.__domComponentMixinLog('render template');
                // }

                render(this.options.template(templatePayload), this.fragment);

                let firstRender = false;
                if (!hasRendered) {
                    firstRender = true;
                    hasRendered = true;
                    // initial render + root element caching + optional appending
                    // render(this.options.template(templatePayload), this.fragment);
                    this.__domComponentMixinLog('render template - first render - register element');
                    this.el = this.fragment.firstElementChild;
                    if (this.options.appendTo) {
                        if (devMode) {
                            this.__domComponentMixinLog('render template - first render - append child');
                        }
                        this.options.appendTo.appendChild(this.el);
                    } else if (this.options.insertBefore) {
                        if (devMode) this.__domComponentMixinLog('first render - insert before child');
                        this.options.insertBefore.parentNode.insertBefore(this.el, this.options.insertBefore);
                    }
                    this.ui = cacheUI(this.el);

                    resolveFirstRender();
                }
                if (this.onRender) {
                    if (devMode) {
                        this.__domComponentMixinLog('render template - invoke hook');
                    }

                    this.onRender(firstRender);
                }
            };

            if (this.props) {
                this.__domComponentDisposeObserve = observe(renderTemplate);
            } else {
                renderTemplate();
            }

            return promiseFirstRender;
        }
    },

    onDestroy() {
        if (devMode) this.__domComponentMixinLog('onDestroy()');

        if (this.props) {
            if (devMode) this.__domComponentMixinLog('onDestroy() - dispose compute');
            this.__domComponentDisposeObserve();
        }

        if (this.fragment) {
            if (devMode) this.__domComponentMixinLog('onDestroy() - reset rendered template');
            render(null, this.fragment);
        }

        if (this.el && this.el.parentNode) {
            if (devMode) this.__domComponentMixinLog('onDestroy() - remove element from dom');
            this.el.parentNode.removeChild(this.el);
        }
    },
};

export default DomComponentMixin;
